import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { TAccountRegion, TBrickSale, TCompetitorSale, TRegionBrick } from '@shared/interfaces/TProject';
import { computeMomentumLong, computeMomentumShort } from '@shared/utils/computeMomentum';
import { isNullOrUndefined } from '@shared/utils/isNullOrUndefined';
import { csvToJson } from 'src/app/helpers/csv-to-json.helper';
import { LoadingService } from 'src/app/services/loading.service';
import { TBaseSettingsTabParams } from '../project-settings.component';

@Component({
  selector: 'app-bricks-competitors',
  templateUrl: './bricks-competitors.component.html',
  styleUrls: ['./bricks-competitors.component.scss'],
})
export class BricksCompetitorsComponent implements OnInit {
  public params: TBaseSettingsTabParams; selectedRegionId: string | null = null;
  public regions: TAccountRegion[] = [];
  public bricks: TRegionBrick[] = [];
  public regionBricks: TRegionBrick[] = [];
  panelOpenState: boolean[] = [];

  public newMonth: TRegionBrick['sales'][number] = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    sales: 0,
    patients: 0,
    salesInEuro: 0,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TBaseSettingsTabParams,
    public dialogRef: MatDialogRef<BricksCompetitorsComponent>,
    public importBricksDialog: MatDialog,
    private _loadingService: LoadingService,
  ) {
    this.params = data;
  }

  ngOnInit(): void {
    this.regions = this.params.selectedProject?.accountRegions ?? [];
    // console.log('Regions:', this.regions);
    // console.log('Regions:', this.regions);
  }

  onRegionChange(): void {
    this.refreshBricks();
    // console.log('REFRESH bricks', this.bricks);
  }

  // get region bricks
  private refreshBricks(): void {
    this.bricks = this.params.selectedProject?.accountBricks || [];
    // sort competitors by name
    this.bricks.forEach((brick, index) => {
      if (brick.salesCompetitors && brick.salesCompetitors.length > 0) {
        // if no competitors, set to empty array
        this.bricks[index].salesCompetitors = brick.salesCompetitors.sort((a, b) => {
          if (a.competitorName < b.competitorName) return -1;
          if (a.competitorName > b.competitorName) return 1;
          return 0;
        });
      } else {
        this.bricks[index].salesCompetitors = [];
      }
    });
    this.regionBricks = this.bricks.filter((b) => b.regionId === this.selectedRegionId) ?? [];
    // console.log('Refresh BRICKS project', this.params.selectedProject);
    // console.log('Refresh BRICKS this.bricks', this.bricks);
    // console.log('Refresh BRICKS this.filteredBricks', this.filteredBricks);
  }

  deleteCompetitor(brick: TRegionBrick, competitor: TCompetitorSale): void {
    // const index = this.params.selectedProject?.accountBricks.findIndex((b) => b.id === brick.id) ?? -1;
    // if (index !== -1) {
    //   this.params.selectedProject!.accountBricks[index].salesCompetitors = this.params.selectedProject!.accountBricks[index].salesCompetitors?.filter((c) => c.competitorId !== competitor.competitorId);
    // }
    this.params.selectedProject!.accountBricks.forEach((b) => {
      if (b.id === brick.id && b.regionId === brick.regionId) {
        b.salesCompetitors = b.salesCompetitors?.filter((c) => c.competitorId !== competitor.competitorId);
      }
    });
  }

  isMonthValid(competitor: TCompetitorSale): boolean {
    // has year and month, year is unique for brick, month is unique for brick
    return (Boolean(this.newMonth.year) && Boolean(this.newMonth.month) && !competitor.sales.some((s) => s.year === this.newMonth.year && s.month === this.newMonth.month));
  }

  addMonth(competitor: TCompetitorSale): void {
    if (this.newMonth.year && this.newMonth.month) {
      const newMonth = structuredClone(this.newMonth);
      competitor.sales.push(newMonth);
    }
    this.updateMomentum(competitor);
  }

  deleteMonth(competitor: TCompetitorSale, month: TBrickSale): void {
    const index = competitor.sales.findIndex((s) => s.year === month.year && s.month === month.month);
    competitor.sales.splice(index, 1);
    this.updateMomentum(competitor);
  }

  /**
   * Handles import of competitors metric (sales, salesInEuro, or patients) from a CSV file.
   * @param e - The file input change event
   * @param metricKey - The metric to import: 'sales', 'salesInEuro', or 'patients'
   */
  public importCompetitors(e: Event, metricKey: 'sales' | 'salesInEuro' | 'patients'): void {
    this.bricks = this.params.selectedProject?.accountBricks || [];
    // console.log('IMPORT COMPETITORS START project', this.params.selectedProject);
    // console.log('IMPORT COMPETITORS START bricks', this.bricks);
    const target: HTMLInputElement = <HTMLInputElement>e.target;
    if (!isNullOrUndefined(target.files)) {
      const file = target.files[0];
      const reader: FileReader = new FileReader();
      reader.onload = (event) => {
        const results = event?.target?.result ?? '';
        if (!isNullOrUndefined(results) && typeof results === 'string') {
          // Parse CSV, handle errors
          const rows = csvToJson(results, ';');
          // console.log('Parsed CSV rows:', rows);
          if (rows.length === 0) {
            this._loadingService.triggerErrorMessage('CSV contains no rows.');
            return
          }
          if (!Object.keys(rows[0]).includes('region_id')) {
            this._loadingService.triggerErrorMessage('CSV contains no region_id.');
            return
          }
          if (!Object.keys(rows[0]).includes('name')) {
            this._loadingService.triggerErrorMessage('CSV contains no brick name.');
            return
          }
          if (!Object.keys(rows[0]).includes('id')) {
            this._loadingService.triggerErrorMessage('CSV contains no brick id.');
            return
          }
          if (!Object.keys(rows[0]).includes('competitor')) {
            this._loadingService.triggerErrorMessage('CSV contains no competitor.');
            return
          }

          // Find all date columns
          const dateColumns = Object.keys(rows[0]).filter((col) => !['region_id', 'name', 'id', 'competitor'].includes(col));
          // console.log('Date columns found:', dateColumns);
          if (dateColumns.length === 0) {
            this._loadingService.triggerErrorMessage('CSV contains no date columns.');
            return
          }

          rows.forEach((row, rowIndex) => {
            if (!row.region_id || !row.id || !row.competitor) return;
            // console.log(`1. Processing row ${rowIndex + 1}:`, row);
            // Find brick
            const brick: TRegionBrick | undefined = this.bricks.find(brick => brick.id === row.id && brick.regionId === row.region_id);

            if (!brick) {
              // console.error(`Brick not found for row ${rowIndex + 1}:`, row);
              this._loadingService.triggerErrorMessage(`Brick not found for row ${rowIndex + 1}: ${row.name} (${row.id}) in region ${row.region_id}`);
              // Skip to next row
              return;
            }

            // Find or create competitor in brick
            let competitorId = this.params?.selectedProject?.competitors.find(competitor => competitor.name.trim().toLowerCase() === row.competitor.trim().toLowerCase())?.id;
            let competitor: TCompetitorSale | undefined;
            if (competitorId) {
              competitor = brick.salesCompetitors.find(competitor => competitor.competitorId === competitorId);
            } else {
              competitor = brick.salesCompetitors.find(competitor => competitor.competitorName.trim().toLowerCase() == row.competitor.trim().toLowerCase());
            }
            if (competitor === undefined) {
              competitor = {
                competitorName: row.competitor.trim(),
                competitorId: competitorId ? competitorId : (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2)),
                patientsMomentumShort: 0,
                patientsMomentumLong: 0,
                // salesMomentumShort: 0,
                // salesMomentumLong: 0,
                // salesInEuroMomentumShort: 0,
                // salesInEuroMomentumLong: 0,
                sales: []
              };
              brick.salesCompetitors.push(competitor);
            }

            // For each date column, update or add sale
            dateColumns.forEach(dateCol => {
              const [m, y] = dateCol.split('/');
              const month = parseInt(m, 10);
              const year = parseInt(y, 10);
              if (isNaN(month) || isNaN(year)) return;
              const value = row[dateCol];
              let sale = competitor?.sales?.find(s => s.month === month && s.year === year);
              if (sale) {
                if (metricKey === 'sales') {
                  sale.sales = (value === undefined || value === '') ? (sale.sales ? sale.sales : 0) : Number(value);
                  if (sale.salesInEuro === undefined) sale.salesInEuro = 0;
                  if (sale.patients === undefined) sale.patients = 0;
                } else if (metricKey === 'salesInEuro') {
                  sale.salesInEuro = (value === undefined || value === '') ? (sale.salesInEuro ? sale.salesInEuro : 0) : Number(value);
                  if (sale.sales === undefined) sale.sales = 0;
                  if (sale.patients === undefined) sale.patients = 0;
                } else if (metricKey === 'patients') {
                  sale.patients = (value === undefined || value === '') ? (sale.patients ? sale.patients : 0) : Number(value);
                  if (sale.sales === undefined) sale.sales = 0;
                  if (sale.salesInEuro === undefined) sale.salesInEuro = 0;
                }
              } else {
                // if no sale exists for this month/year, create a new one
                competitor?.sales?.push({
                  month,
                  year,
                  sales: metricKey === 'sales' ? Number(value) : 0,
                  salesInEuro: metricKey === 'salesInEuro' ? Number(value) : 0,
                  patients: metricKey === 'patients' ? Number(value) : 0,
                });
              }
            });
            // Update momentum for the competitor
            this.updateMomentum(competitor);
            // console.log(`2. Updated competitor ${competitor.competitorName} in brick ${brick.name} for row ${rowIndex + 1}`, competitor);
                        // Update project bricks
            if (this.params.selectedProject) {
              this.params.selectedProject.accountBricks = [...this.bricks];
            }
          });
        } else {
          // console.error('File read error: results is not a string');
          this._loadingService.triggerErrorMessage('File read error: result is not a string');
        }
        // // update project bricks
        // // TODO check if it needs changing (region bricks?)
        // this.bricks.forEach((rBrick) => {
        //   // const pbIndex = this.params?.selectedProject?.accountBricks.findIndex(pBrick => pBrick.id === rBrick.id) || -1;
        //   // if (pbIndex !== -1 && this.params?.selectedProject?.accountBricks) {
        //   //   this.params.selectedProject.accountBricks[pbIndex] = rBrick;
        //   // }
        //   this.params?.selectedProject?.accountBricks.forEach((pBrick) => {
        //     if (pBrick.id === rBrick.id) { pBrick = rBrick; }
        //   });
        // });
        // this.refreshBricks();
        // console.log('IMPORT COMPETITORS END - project', this.params.selectedProject);
        this._loadingService.triggerOkMessage(`Competitors ${metricKey} imported successfully!`);
      };
      reader.readAsText(file);
    }
  }

  // public importCompetitorsSalesCallback(e: Event): void {
  //   const target: HTMLInputElement = <HTMLInputElement>e.target;
  //   if (!isNullOrUndefined(target.files)) {
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (event) => {
  //       const results = event?.target?.result ?? '';
  //       if (!isNullOrUndefined(results) && typeof results === `string`) {
  //         const csvOutput = CSVUtils.csvToArray(results);
  //         this._openImportCompetitorsSalesDialog(csvOutput.headers, e);
  //       }
  //     };
  //     reader.readAsText(target.files[0]);
  //   }
  // }

  // public importCompetitorsSalesInEuroCallback(e: Event): void {
  //   const target: HTMLInputElement = <HTMLInputElement>e.target;
  //   if (!isNullOrUndefined(target.files)) {
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (event) => {
  //       const results = event?.target?.result ?? '';
  //       if (!isNullOrUndefined(results) && typeof results === `string`) {
  //         const csvOutput = CSVUtils.csvToArray(results);
  //         this._openImportCompetitorsSalesInEuroDialog(csvOutput.headers, e);
  //       }
  //     };
  //     reader.readAsText(target.files[0]);
  //   }
  // }

  // public importCompetitorsPatientsCallback(e: Event): void {
  //   const target: HTMLInputElement = <HTMLInputElement>e.target;
  //   if (!isNullOrUndefined(target.files)) {
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (event) => {
  //       const results = event?.target?.result ?? '';
  //       if (!isNullOrUndefined(results) && typeof results === `string`) {
  //         const csvOutput = CSVUtils.csvToArray(results);
  //         this._openImportCompetitorsPatientsDialog(csvOutput.headers, e);
  //       }
  //     };
  //     reader.readAsText(target.files[0]);
  //   }
  // }

  public sortMonths(competitor: TCompetitorSale): any[] {
    return competitor.sales.sort((a: TBrickSale, b: TBrickSale) => {
      if (a.year === b.year) { return b.month - a.month }
      return b.year - a.year;
    });
  }

  // private _openImportCompetitorsSalesDialog(headers: string[], e: Event): void {
  //   this.importBricksDialog.open<ImportComponent, TImportData>(
  //     ImportComponent,
  //     {
  //       width: '80%',
  //       data: {
  //         headers: headers,
  //         projectId: this.params.selectedProject!.id,
  //         area: ImportArea.CompetitorsSales,
  //         e,
  //         importCallback: (e, mappings) => this.importCompetitorsSales(e, mappings),
  //       },
  //     }
  //   );
  // }

  // private _openImportCompetitorsSalesInEuroDialog(headers: string[], e: Event): void {
  //   this.importBricksDialog.open<ImportComponent, TImportData>(
  //     ImportComponent,
  //     {
  //       width: '80%',
  //       data: {
  //         headers: headers,
  //         projectId: this.params.selectedProject!.id,
  //         area: ImportArea.CompetitorsSalesInEuro,
  //         e,
  //         importCallback: (e, mappings) => this.importCompetitorsSalesInEuro(e, mappings),
  //       },
  //     }
  //   );
  // }

  // private _openImportCompetitorsPatientsDialog(headers: string[], e: Event): void {
  //   this.importBricksDialog.open<ImportComponent, TImportData>(
  //     ImportComponent,
  //     {
  //       width: '80%',
  //       data: {
  //         headers: headers,
  //         projectId: this.params.selectedProject!.id,
  //         area: ImportArea.CompetitorsPatients,
  //         e,
  //         importCallback: (e, mappings) => this.importCompetitorsPatients(e, mappings),
  //       },
  //     }
  //   );
  // }

  // private importCompetitorsSales(e: Event, mappings: any): void {
  //   if (this.params.selectedProject !== undefined) {
  //     this._importService.importCompetitorsSales(e, () => this.refreshBricks(), this.params.selectedProject.id, mappings);
  //   }
  // }

  // private importCompetitorsSalesInEuro(e: Event, mappings: any): void {
  //   if (this.params.selectedProject !== undefined) {
  //     this._importService.importCompetitorsSalesInEuro(e, () => this.refreshBricks(), this.params.selectedProject.id, mappings);
  //   }
  // }

  // private importCompetitorsPatients(e: Event, mappings: any): void {
  //   if (this.params.selectedProject !== undefined) {
  //     this._importService.importCompetitorsPatients(e, () => this.refreshBricks(), this.params.selectedProject.id, mappings);
  //   }
  // }

  getCompetitorSaleIndex(saleMonth: number, saleYear: number, competitor: TCompetitorSale): number {
    return competitor.sales.findIndex((sale) => +sale.month === +saleMonth && +sale.year === +saleYear);
  }

  // public updateMomentumProxy(event: Event, competitor: TCompetitorSale): void {
  //   // event.stopPropagation();
  //   console.log('updateMomentumProxy called', competitor, event);
  //   this.updateMomentum(competitor);
  // }

  public updateMomentum(competitor: TCompetitorSale): void {
    // sort sales by year and month
    const patients = this.sortCompetitorsSalesChronologically(competitor.sales).map((c) => Number(c.patients));

    // if there are less than 8 sales, set momentum to 0
    // this is because we need at least 8 sales to compute the short momentum
    if (patients.length < 8) {
      competitor.patientsMomentumShort = 0;
      competitor.patientsMomentumLong = 0;
      return;
    }
    competitor.patientsMomentumShort = computeMomentumShort(patients);
    competitor.patientsMomentumLong = computeMomentumLong(patients);
    competitor = { ...competitor };
  }

    private sortCompetitorsSalesChronologically(data: TBrickSale[]): TBrickSale[] {
    return [...data].sort((a, b) => {
      const yearA = Number(a.year);
      const yearB = Number(b.year);
      const monthA = Number(a.month);
      const monthB = Number(b.month);

      if (yearA !== yearB) {
        return yearA - yearB;
      }
      return monthA - monthB;
    });
  }

  getPatientsMomentumShort(competitor: TCompetitorSale): number {
    if (competitor.patientsMomentumShort) return competitor.patientsMomentumShort;
    this.updateMomentum(competitor);
    return competitor.patientsMomentumShort;
  }

  getPatientsMomentumLong(competitor: TCompetitorSale): number {
    if (competitor.patientsMomentumLong) return competitor.patientsMomentumLong;
    this.updateMomentum(competitor);
    return competitor.patientsMomentumLong;
  }

  getBricksWithCompetitors(bricks: TRegionBrick[]): TRegionBrick[] {
    return bricks.filter((brick) => brick.salesCompetitors && brick.salesCompetitors.length > 0);
  }
}
